import { render, staticRenderFns } from "./funes_pres_detalle.vue?vue&type=template&id=6f154466&scoped=true"
import script from "./funes_pres_detalle.vue?vue&type=script&lang=js"
export * from "./funes_pres_detalle.vue?vue&type=script&lang=js"
import style0 from "./funes_pres_detalle.vue?vue&type=style&index=0&id=6f154466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f154466",
  null
  
)

export default component.exports